import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { NotificationTemplateFragmentDoc } from '../../../../notifications/graphql/fragment/generated/notificationTemplate';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GetDefaultAssignmentReminderQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetDefaultAssignmentReminderQuery = { notificationTemplates: { success: boolean, errorCode?: Types.PaginationErrorCodeEnum | null, edges?: Array<{ node: { id: string, name?: string | null, description?: string | null, group?: Types.NotificationGroupTypeEnum | null, actionType: Types.NotificationActionTypeEnum, availableAs: Array<Types.TaskTypeEnum>, defaultReminderType?: Types.ReminderTypeEnum | null, areRemindersGloballyConfigurable?: boolean | null, tasksRequired: { email?: boolean | null, bell?: boolean | null, slack?: boolean | null }, reminderConfigurations?: Array<{ reminderType: Types.ReminderTypeEnum, value: number, unit: Types.ReminderConfigurationUnitTypeEnum }> | null } }> | null } };


export const GetDefaultAssignmentReminderDocument = /*#__PURE__*/ gql`
    query getDefaultAssignmentReminder {
  notificationTemplates(
    filters: {isConfigurable: true, actionTypes: [ASSIGN_CONTENT, DUE_DATE_REMINDER, CONTENT_OVERDUE]}
  ) {
    success
    errorCode
    edges {
      node {
        ...NotificationTemplate
      }
    }
  }
}
    ${NotificationTemplateFragmentDoc}`;

export function useGetDefaultAssignmentReminderQuery(options?: Omit<Urql.UseQueryArgs<GetDefaultAssignmentReminderQueryVariables>, 'query'>) {
  return Urql.useQuery<GetDefaultAssignmentReminderQuery, GetDefaultAssignmentReminderQueryVariables>({ query: GetDefaultAssignmentReminderDocument, ...options });
};